interface ProgressiveEligibility {
    subsidiary?: {country?: {code?: string}};
    is_egames?: boolean;
    system_server_version?: string;
}

// These configurations may keep unassigned groups and have no progressives.
export const allowsOptionalProgressives = (config?: ProgressiveEligibility) => {
    if (!config) return false;

    if (
        config.subsidiary &&
        config.subsidiary.country &&
        config.subsidiary.country.code === "BR"
    ) return true;

    if (!config.is_egames || !config.system_server_version) return false;

    const version = config.system_server_version.match(/^(\d+)\.(\d+)(?:\.|$)/);
    if (!version) return false;

    const major = Number(version[1]);
    const minor = Number(version[2]);
    return major > 2 || (major === 2 && minor >= 11);
};
